
import { Debounce, Bind } from 'lodash-decorators'
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class BookTabs extends Vue {
  @Prop({ default: () => [] }) tabsList: string[]
  @Prop({ default: 0 }) defaultTab: number

  currentTab: number = 0

  @Ref()
  tabActive: HTMLDivElement

  hasInited: boolean = false

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  handleTabClick(idx: number) {
    if (idx === this.currentTab) return

    if (this.hasInited === false) {
      this.currentTab = idx
      this.initTabs()
    } else {
      let offset = this.tabActive.offsetLeft // 获取 activeTabs 的left值

      if (this.currentTab > idx) {
        for (let i = this.currentTab - 1; i >= idx; i--) {
          offset = offset - Math.floor(this.$refs[`tabs-${i}`]?.[0].offsetWidth) - 10
        }
      } else {
        for (let i = this.currentTab; i < idx; i++) {
          offset = offset + Math.floor(this.$refs[`tabs-${i}`]?.[0].offsetWidth) + 10
        }
      }

      this.tabActive.style.left = `${offset}px`

      this.tabActive.style.width = `${Math.floor(this.$refs[`tabs-${idx}`]?.[0].offsetWidth)}px` // 解决不同宽度tabs问题

      this.currentTab = idx
    }

    this.$emit('updateBook', idx)
  }

  // tabs初始化
  initTabs() {
    if (!this.tabsList[this.currentTab]) return

    let offset = 6 // 获取 activeTabs 的left值

    for (let i = 0; i < this.currentTab; i++) {
      offset = offset + Math.floor(this.$refs[`tabs-${i}`]?.[0].offsetWidth) + 10
    }

    this.tabActive.style.left = `${offset}px`

    this.tabActive.style.width = `${Math.floor(this.$refs[`tabs-${this.currentTab}`]?.[0].offsetWidth)}px` // 解决不同宽度tabs问题

    this.hasInited = true
  }

  init() {
    this.currentTab = this.defaultTab
    this.initTabs()
  }

  created(): void {}

  mounted(): void {
    this.init()
  }

  updated(): void {}

  destroyed(): void {}
}
